export const getEndpoint = () => {
  return window.__env.CURRENT_ENV === "prod"
    ? window.__env.REMOTE_ENDPOINT
    : window.__env.LOCAL_ENDPOINT;
};

const incrementTypeMapping: Record<"%" | "weight", string> = {
  "%": "Percentuale",
  weight: "Peso",
};

const intensityTypeMapping: Record<"%" | "nRm", string> = {
  "%": "Percentuale di carico",
  nRm: "nRm",
};

export const getIncrementType = (incrementType: "%" | "weight") => {
  return incrementTypeMapping[incrementType];
};

export const getIntensityType = (intensityType: "%" | "nRm") => {
  return intensityTypeMapping[intensityType];
};

export const capitalize = (str: string): string => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};